import { Link } from "react-scroll";
import {
  Box,
  Button,
  HStack,
  Image,
  useColorMode,
  useColorModeValue,
  useDisclosure,
} from "@chakra-ui/react";
import Resume from "../files/Shubham-Pandey-Resume.pdf";
import { MoonIcon, SunIcon } from "@chakra-ui/icons";
import { NavDrawer } from "../DrawerNavbar/NavDrawer";

const links = [
  {
    class: "nav-link home",
    page: "Home",
    class:"home"
  },
  {
    to: "about",
    page: "About",
    class:"about"
  },
  {
    to: "skill",
    page: "Skill",
    class:"skills"
  },
  {
    to: "project",
    page: "Project",
    class:"projects"
  },
  {
    to: "contact",
    page: "Contact",
    class:"contact"
  },
  // {
  //   to:{Resume},
  //   page:"Resume"
  // }
];
export function Navbar() {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { colorMode, toggleColorMode } = useColorMode();
  const NavBgColor = useColorModeValue("gray.50", "gray.900");

  return (
    <div  >
      <Box
        id="nav-menu"
        bgColor={NavBgColor}
        position="sticky"
        top={"0px"}
        left="0px"
        zIndex={1}
      >
        <HStack
          justifyContent="space-between"
          paddingLeft={"30px"}
          paddingRight="4rem"
          height="5rem"
          fontWeight="bold"
          // fontSize="35px"
        >
          <Box className="home">
            <Link className="nav-link" to="home"></Link>
          </Box>
          <Box display={{ base: "none", sm: "none", md: "inline-flex" }}>
            <HStack gap={"30px"} height="6rem"  >
              {links.map((el, i) => (
                <Link
                  key={i}
                  className={`nav-link ${el.class}`}
                  activeClass="active"
                  smooth
                  spy
                  to={el.to}
                  offset={-70}
                  duration={500}
                >
                  {el.page}
                </Link>
              ))}
              <button id="resume-button-1" style={{fontSize:"18px", background:"null", fontWeight:"bold"}}>

              <a   id="resume-link-1" className="nav-link resume" href="https://drive.google.com/file/d/1HP44WvGLh66ptUDZnPPPNwZviKAFkOTH/view" target="_blank" >Resume</a>

              </button>
              <Button
                borderRadius={"50%"}
                width="42px"
                onClick={toggleColorMode}
              >
                {colorMode === "dark" ? <SunIcon /> : <MoonIcon />}
              </Button>
            </HStack>
          </Box>
          {/* ----------tablet and mobile hubergicon------------ */}
          <Box display={{ base: "inline-flex", sm: "inline-flex", md: "none" }}>
            <HStack gap={"20px"}>
              <Button
                borderRadius={"50%"}
                width="42px"
                onClick={toggleColorMode}
              >
                {colorMode === "dark" ? <SunIcon /> : <MoonIcon />}
              </Button>
              <Box>
                <NavDrawer isOpen={isOpen} onOpen={onOpen} onClose={onClose} />
              </Box>
            </HStack>
          </Box>
        </HStack>
      </Box>
    </div>
  );
}
